/**
 * Created by Sergii on 04.10.2018.
 */
import {UserActions, UsersTableActions} from '../const/ActionsConst';
import * as actions from './index.js';
import {loadUsers} from "./UsersTableActions";

import client from '@common/utils/rest.js'
const I18n = require('react-redux-i18n').I18n;

export const showNewUserWnd = (show) => ({
    type: UserActions.SHOW_NEW_USER_WND,
    newUser: {
        show: show
    }
});

export const updateNewUserData = (field, value) => ({
    type: UserActions.UPDATE_NEW_USER_DATA,
    newUser: {
        field: field,
        value: value
    }
});

export const addNewUser = () => async (dispatch,getState) => {
    const { password, retypedPassword, username } = getState().newUser;
    const maxUsernameLength = 70;
    let usernameTaken;

    if (username) {
        try {
            const user = await client({
                path: `api/userMaintenance/users/${username}`,
                method: 'GET',
            });

            if (user) {
                usernameTaken = true;
            }
        } catch {
            usernameTaken = false;
        }
    }

    const validations = [
        { condition: !username, message: I18n.t('Please enter a name for the new user') },
        { condition: usernameTaken, message: I18n.t('userAlready', { name: username }) },
        { condition: !password || password.length === 0, message: I18n.t('pwNewUser') },
        { condition: password !== retypedPassword, message: I18n.t('Two different passwords were entered in the password fields') },
        { condition: username.length > maxUsernameLength, message: `${I18n.t('The maximum name length is')} ${maxUsernameLength}` },
        { condition: actions.containsSpecialCharacters(username), message: I18n.t('Username cannot contain special characters except underscore (_) or dash (-)') },
    ];

    const errorMessage = validations.find((x) => x.condition)?.message;

    if (errorMessage) {
        dispatch(actions.showMessageBoxBasedOnData(undefined, true, I18n.t('Add User Canceled'), errorMessage, undefined, I18n.t('OK')));

        return;
    }


    var userData = {
        username: username,
        password: password,
        retypedPassword: retypedPassword
    };
    client({
        path: 'api/userMaintenance/addUser',
        method: 'POST',
        entity: userData
    }).then(
        response => {
            if (response.entity.error) {
                var errorKey = response.entity.error;
                let errorMessage = '';
                if(response.entity.error.includes("Passwords must be at least")) {
                    errorMessage = response.entity.error;
                } else if(response.entity.error.includes("Passwords cannot contain the username")) {
                    errorKey = "pwNoUsername";
                } else if(response.entity.error.includes("password you entered is the same as your previous")) {
                    errorKey = "pwSamePrevious";
                } else if(response.entity.error.includes("enter a password for the new user")) {
                    errorKey = "pwNewUser";
                } else if(response.entity.error.includes("does not meet requirements")) {
                    errorKey = "pwRequirements";
                } else if(response.entity.error.includes("There is already a user named")) {
                    errorMessage = response.entity.error;
                } else if(response.entity.error.includes("Usernames cannot start with a number")) {
                    errorKey = "userNumber";
                } else if(response.entity.error.includes("Usernames cannot contain single")) {
                    errorKey = "userQuotes";
                } else if(response.entity.error.includes("Usernames cannot contain colons")) {
                    errorKey = "userColons";
                } else if(response.entity.error.includes("PROGGRP is a reserved word")) {
                    errorKey = "userProggrp";
                } else if(response.entity.error.includes("inserting user into the st_users")) {
                    errorKey = "userSTusers";
                } else if(response.entity.error.includes("giving a user GRANT permissions")) {
                    errorKey = "userGrant";
                } else if(response.entity.error.includes("giving a user WEB access")) {
                    errorKey = "userWeb";
                } else if(response.entity.error.includes("is a reserved word")) {
                    errorMessage = `${username} ${I18n.t('reservedWord')}`
                }
                dispatch(actions.showMessageBoxBasedOnData(undefined, true, I18n.t('Add User Canceled'), errorMessage || I18n.t(errorKey), undefined, I18n.t('OK')));
            } else {
                dispatch(clearNewUserData());
                dispatch(loadUsers())
            }
        },
        error => {console.log('addNewUser: ', error);}
    )
};

export const clearNewUserData = () => ({
    type: UserActions.CLEAR_NEW_USER_DATA
});